<div class="alert alert-warning mb-0" role="alert">
  <fa-icon [icon]="['fas', 'exclamation-triangle']" size="lg"></fa-icon>
  <strong>You currently have view only access to Loadshop.</strong>
  <p class="text-center mt-3 col-md-8">Your access has changed.</p>
  <span>Please contact <a href="Loadshop@kbxlogistics.com">Loadshop&#64;kbxlogistics.com</a> with any questions.</span>
</div>
